// import Visibility from "@mui/icons-material/Visibility"
// import VisibilityOff from "@mui/icons-material/VisibilityOff"
import { BoxProps, /* IconButton */ TextField, Typography } from "@mui/material"
import InputAdornment from "@mui/material/InputAdornment"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useRecoilState } from "recoil"
import { SNACKBAR_TYPES } from "src/modules/const"
import { ShowToast } from "src/states/showToast"
import { Box } from "src/UILibrary"
import "./index.scss"

type Props = {
  sx?: BoxProps
  name?: string
  placeholder?: string
  required?: boolean
  multiline?: boolean
  text: string
  handleText?: any
  checkValidation?: any
  disabled?: boolean
  adornment?: string
  validationMessage?: string
  password?: boolean
  handleFocusOut?: any
  handleKeyUp?: any
  className?: any
  inputStyle?: any
  description?: string
  readOnly?: boolean
  maxLength?: number
  fontSize?: number
}

const InputTextField = ({
  sx,
  name,
  placeholder,
  required,
  multiline,
  text,
  handleText,
  checkValidation,
  disabled,
  adornment,
  validationMessage,
  password,
  handleFocusOut,
  handleKeyUp,
  className,
  inputStyle,
  description,
  readOnly,
  maxLength,
  fontSize,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "base" })

  const [, setShowToast] = useRecoilState(ShowToast)

  const [showPassword /*setShowPassword*/] = useState<boolean>(false)

  const placeholderStyle = {
    "& ::placeholder": {
      fontFamily: "Zen Kaku Gothic New !important",
    },
    "& ::before": {
      borderColor: "#d4d3d7 !important",
    },
  }

  const style = sx || {}

  useEffect(() => {
    if (maxLength && text.length > maxLength) {
      setShowToast({
        show: true,

        text: t("please_input_less_than_characters", { length: maxLength }),
        type: SNACKBAR_TYPES.WARNING,
      })
      handleText(text.slice(0, maxLength))
    }
  }, [text])

  return (
    <Box
      className={`input_text ${className}`}
      sx={{
        ...style,
        ...placeholderStyle,
      }}
    >
      {name && (
        <Box display="flex">
          <Typography className="name">{name}</Typography>
          {required && (
            <Box className="required-container">
              <Typography className="required">{t("required")}</Typography>
            </Box>
          )}
        </Box>
      )}
      {password ? (
        <TextField
          className="input_text_field"
          variant="outlined"
          placeholder={placeholder}
          autoComplete="off"
          sx={{
            fontFamily: "Zen Kaku Gothic New !important",
            width: "340px",
            ...inputStyle,
            mt: name ? "10px" : "0px",
            ".Mui-readOnly": {
              backgroundColor: "#EAF1FB",
            },
            "& fieldset": { borderColor: "#F3F3F3" },
            "& .MuiInputBase-input": { px: "10px" },
            input: {
              "&::placeholder": {
                color: inputStyle.placeColor ? inputStyle.placeColor : "#B9B9B9",
                opacity: 1,
              },
            },
          }}
          type={password && !showPassword ? "password" : "text"}
          value={text}
          onChange={(event) => handleText!(event.target.value)}
          onKeyUp={() => {
            if (checkValidation) {
              checkValidation()
            }
          }}
          InputProps={{
            // endAdornment: (
            //   <InputAdornment position="end">
            //     <IconButton
            //       aria-label="toggle password visibility"
            //       onClick={() => setShowPassword(!showPassword)}
            //       edge="end"
            //     >
            //       {showPassword ? <VisibilityOff /> : <Visibility />}
            //     </IconButton>
            //   </InputAdornment>
            // ),
            style: {
              fontSize: fontSize ? fontSize : 14,
              height: "100%",
              letterSpacing: "0px",
              color: inputStyle?.color,
            },
          }}
        />
      ) : (
        <TextField
          className="input_text_field"
          variant="outlined"
          placeholder={placeholder}
          autoComplete="off"
          sx={{
            fontFamily: "Zen Kaku Gothic New !important",
            width: "340px",
            ".Mui-readOnly": {
              backgroundColor: "#EAF1FB",
            },
            "& fieldset": { borderColor: "#F3F3F3" },
            "& .MuiInputBase-input": {
              px: "10px",
            },
            input: {
              "&::placeholder": {
                color: inputStyle.placeColor ? inputStyle.placeColor : "#B9B9B9",
                opacity: 1,
              },
            },
            ...inputStyle,
            mt: name ? "10px" : "0px",
          }}
          multiline={multiline}
          minRows={multiline ? 4 : 1}
          maxRows={multiline ? 10 : 1}
          disabled={disabled}
          type={password ? "password" : "text"}
          value={text}
          onChange={(event) => handleText!(event.target.value)}
          onBlur={(event) => (handleFocusOut ? handleFocusOut(event?.target.value) : {})}
          onKeyUp={(event) => {
            handleKeyUp ? handleKeyUp(event) : {}
            if (checkValidation) {
              checkValidation()
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <Typography className="text-adornment">{adornment}</Typography>
              </InputAdornment>
            ),
            style: {
              fontSize: fontSize ? fontSize : 14,
              height: "100%",
              letterSpacing: "0px",
              color: inputStyle?.color,
            },
            readOnly,
          }}
        />
      )}
      {validationMessage ? (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography className="description error">{validationMessage}</Typography>
        </Box>
      ) : description ? (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography className="description">{description}</Typography>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default InputTextField
